export type FreeMagicFaqItem = {
  question: string
  /** Plain text or a small HTML fragment (links, `<strong>`). */
  answerHtml: string
}

export const FREE_MAGIC_FAQ_ITEMS: FreeMagicFaqItem[] = [
  {
    question: 'Are these free magic downloads really free?',
    answerHtml:
      'Yes—there is no charge to add these titles to your library. You only need a free Vanishing Inc. account.',
  },
  {
    question: 'Do I need a credit card to get free magic downloads?',
    answerHtml:
      'No. Creating an account is free and you are not required to add a payment method to claim free magic downloads.',
  },
  {
    question: 'Where do my free magic downloads go?',
    answerHtml:
      'They appear in <a href="/account/downloads/" class="text-vi-red hover:underline">your downloads</a> alongside any paid magic downloads you own—same place, same streaming and re-download options.',
  },
  {
    question: 'What kinds of free magic downloads can I get?',
    answerHtml:
      'This collection includes digital video, ebooks, lecture-style material, introductions from working pros, sample chapters, documentary extras, and community resources. Each listing is a full product page with full details.',
  },
  {
    question: 'How do I add a free magic download to my library?',
    answerHtml:
      'Open any title above, sign in (or register for free), then use <strong>Free download</strong> on the product page to add it to your account. You can access it from your library on any device.',
  },
  {
    question: 'Can I stream or download more than once?',
    answerHtml:
      'Yes. Free magic downloads stay in your account so you can stream or download again whenever you like.',
  },
  {
    question: 'What is the difference between free magic downloads and paid?',
    answerHtml:
      'Free magic downloads are selected titles you can claim at no cost. Our full <a href="/magic-downloads/" class="text-vi-red hover:underline">magic downloads</a> store includes a much larger catalog of instruction videos, ebooks, and exclusives for purchase. For category shortcuts, use the links at the bottom of this page.',
  },
]
